/* Nordic Performance v2.1 — interaction enhancements */
(function () {
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  // header glass state on scroll
  var header = document.querySelector('.np-header');
  if (header) {
    var onScroll = function () { header.classList.toggle('np-scrolled', window.scrollY > 8); };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  // highlight current nav item
  try {
    var here = location.pathname;
    document.querySelectorAll('.np-menu a').forEach(function (a) {
      var href = a.getAttribute('href') || '';
      var path = href.split('#')[0];
      if (path === here || (here !== '/' && path.length > 1 && here.indexOf(path) === 0)) {
        a.setAttribute('aria-current', 'page');
      }
    });
  } catch (e) {}

  if (reduce || !('IntersectionObserver' in window)) return;

  // staggered reveal for grids
  var groups = document.querySelectorAll('.np-features,.cards,.np-rail,.steps,.stats,.np-colcards,.flip-row,.reviews');
  if (groups.length) {
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (en) { if (en.isIntersecting) { en.target.classList.add('np-in'); io.unobserve(en.target); } });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    groups.forEach(function (g) { g.classList.add('np-stagger'); io.observe(g); });
    setTimeout(function () { groups.forEach(function (g) { g.classList.add('np-in'); }); }, 2200);
  }

  // count-up for stat numbers
  var nums = document.querySelectorAll('.stat .big');
  if (nums.length) {
    var io2 = new IntersectionObserver(function (es) {
      es.forEach(function (en) {
        if (!en.isIntersecting) return;
        io2.unobserve(en.target);
        var el = en.target, m = el.textContent.trim().match(/^(\D*)([\d.,]+)(.*)$/);
        if (!m) return;
        var pre = m[1], post = m[3], numStr = m[2];
        var dec = (numStr.split(/[.,]/)[1] || '').length;
        var target = parseFloat(numStr.replace(/,/g, '.'));
        if (isNaN(target)) return;
        var start = performance.now(), dur = 1100;
        (function tick(now) {
          var p = Math.min(1, (now - start) / dur), e = 1 - Math.pow(1 - p, 3);
          el.textContent = pre + (target * e).toFixed(dec) + post;
          if (p < 1) requestAnimationFrame(tick);
        })(start);
      });
    }, { threshold: 0.4 });
    nums.forEach(function (n) { io2.observe(n); });
  }

  // cart badge bump when count changes
  var badge = document.querySelector('[data-cart-count]');
  if (badge) {
    var last = badge.textContent;
    new MutationObserver(function () {
      if (badge.textContent !== last) {
        last = badge.textContent;
        badge.classList.remove('np-bump'); void badge.offsetWidth; badge.classList.add('np-bump');
      }
    }).observe(badge, { childList: true, characterData: true, subtree: true });
  }
})();
